export const petType = [
  { value: "cat", label: "Chat", iconUrl: "/assets/media/cat.png" },
  { value: "dog", label: "Chien", iconUrl: "/assets/media/dog.png" },
];
